<template>
  <button
    :class="
      cn(
        'relative inline-flex h-12 overflow-hidden rounded-full p-[2px] focus:outline-none focus:ring-0 active:outline-none',
        className
      )
    "
    v-bind="$attrs"
    @click="handleClick"
  >
    <span
      class="absolute inset-[-1000%] animate-[spin_1.5s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#ffffff_0%,#dbeafe_25%,#3b82f6_50%,#1d4ed8_75%,#ffffff_100%)]"
    />
    <span
      :class="
        cn(
          'inline-flex h-full w-full cursor-pointer items-center justify-center rounded-full px-3 py-1 text-sm font-medium backdrop-blur-3xl',
          containerClassName
        )
      "
    >
      <slot />
    </span>
  </button>
</template>

<script setup>
import { computed } from "vue";

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  className: {
    type: String,
    default: "",
  },
  containerClassName: {
    type: String,
    default: "",
  },
  borderRadius: {
    type: String,
    default: "1.75rem",
  },
  scrollTo: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["click"]);

// Simple class name utility function
function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

function handleClick(event) {
  if (props.scrollTo) {
    const element = document.getElementById(props.scrollTo);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }
  emit("click", event);
}
</script>

<style scoped>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
